<template>
  <v-banner class="login-banner" lines="one">
    <template v-slot:prepend>
      <v-icon color="primary" size="24"> mdi-account-outline </v-icon>
    </template>
    <v-banner-text>Vous n'êtes pas connecté</v-banner-text>
    <template v-slot:actions>
      <v-btn color="primary" variant="text" :to="{ name: 'connexion' }"> Connexion </v-btn>
    </template>
  </v-banner>
</template>

<style scoped>
  .login-banner {
    width: 100%;
  }
</style>
